<template>
  <div class="vip-detail-content-component"
       :class="{ 'in-app': isAppWebView && vip.id !== 8, 'new': vip.id === 8 }"
  >
    <div class="vip-detail-content-header">
      <ym-img class="vip-detail-content-cover"
              :src="vip.headerCover"
      />
      <div class="vip-detail-content-price-container">
        <div class="vip-detail-content-price-name">
          {{ primaryPrice.current.name }}
        </div>
        <div class="vip-detail-content-price">
          <div class="vip-detail-content-price-current">
            <span v-if="currentPrice > 0"
                  class="vip-detail-content-price-current-unit"
            >¥</span>
            <span class="vip-detail-content-price-current-value"
            >{{ currentPriceText }}</span>{{ vip.unit ? `/${vip.unit}` : '' }}
          </div>
          <del v-if="showDeletePrice"
               class="vip-detail-content-price-delete"
          >
            ¥{{ primaryPrice.origin.value }}
          </del>
        </div>
      </div>
    </div>

    <div class="vip-detail-content-about">
      <div v-if="groupBuy && groupBuy.activity"
           class="vip-detail-content-group-buy"
      >
        <!-- 拼团 -->
        <group-buy-block-header v-if="!showGroupBuyList"
                                class="vip-detail-content-group-buy-header"
                                :rule="groupBuy.activity.rule"
                                :start-time="groupBuy.activity.currentTime"
                                :end-time="groupBuy.activity.endTime"
                                :show-countdown="groupBuy.activity.showCountdown"
        />
        <group-buy-block v-if="showGroupBuyList"
                         class="vip-detail-content-group-buy-block"
                         :id="groupBuy.activity.id"
                         :desc="groupBuy.activity.desc"
                         :rule="groupBuy.activity.rule"
                         :start-time="groupBuy.activity.currentTime"
                         :end-time="groupBuy.activity.endTime"
                         :list="groupBuy.activity.team.list"
                         :max-list-num="groupBuy.activity.team.max"
                         :show-countdown="groupBuy.activity.showCountdown"
        />
      </div>

      <rich-text ref="richTextComponent"
                 class="vip-detail-content-content"
                 :content="vip.about"
                 :percent-grain-list="percentGrainList"
      />
    </div>
  </div>
</template>

<script>
  import GroupBuyBlockHeader from '@/pages/GroupBuy/components/ProductDetailBlockHeader';
  import GroupBuyBlock from '@/pages/GroupBuy/components/ProductDetailBlock';
  import RichText from '@/components/RichText';
  import { isAppWebView } from '@/utils';
  import pageScrollPercentMixin from '@/mixins/report/pageScrollPercent';

  export default {
    name: 'VipDetailContent',
    mixins: [pageScrollPercentMixin],
    components: {
      GroupBuyBlockHeader,
      GroupBuyBlock,
      RichText,
    },
    props: {
      vip: {
        type: Object,
        required: true,
      },
      primaryPrice: {
        type: Object,
        required: true,
      },
      groupBuy: null,
    },
    data() {
      return {
        isAppWebView: isAppWebView(),
      };
    },
    computed: {
      currentPrice() {
        const { primaryPrice: { current: { value } } } = this;
        return value;
      },
      currentPriceText() {
        const { currentPrice } = this;
        if (currentPrice <= 0) {
          return '免费';
        }
        return currentPrice;
      },
      groupBuyTeamLength() {
        if (!this.groupBuy || !this.groupBuy.activity) return 0;
        return this.groupBuy.activity.team.list.length;
      },
      showGroupBuyList() {
        return this.groupBuyTeamLength > 0;
      },
      showDeletePrice() {
        const { primaryPrice } = this;
        return primaryPrice.current.value < primaryPrice.origin.value;
      },
    },
    methods: {
      controlScrollHandler() {
        setTimeout(() => {
          if (!this.$refs.richTextComponent) return;
          const rect = this.$refs.richTextComponent.$el.getBoundingClientRect();
          this.pageScrollHandler(rect);
        }, 1000);
      },
    },
    created() {
      this.controlScrollHandler();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .vip-detail-content {
    &-component {
      background: @color-white;
      min-height: 120vh;
    }

    &-header {
      position: relative;
    }

    &-cover {
      display: block;
      width: 100%;
    }

    &-price {
      display: flex;
      align-items: flex-end;
      font-size: @vip-detail-price-container-font-size;

      &-container {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 468px;
        height: 228px;
        position: absolute;
        top: 550px;
        left: 0;
        padding: 62px 20px 60px 30px;
        color: @color-text-base;
        line-height: 1.2;
        background: url("~@/assets/img/vip/vip_detail_price_bg.png") no-repeat 0 0;
        background-size: contain;
        &.gift {
          bottom: 350px;
        }
      }

      &-name {
        font-size: @vip-detail-price-name-font-size;
        font-weight: @font-weight-bold;
      }

      &-current {
        white-space: nowrap;
        line-height: 1;
        color: @color-text-highlight;

        &-unit {
          margin-right: @size-extra-small;
        }

        &-value {
          font-size: @vip-detail-price-font-size;
          font-weight: @font-weight-bold;
        }
      }

      &-delete {
        margin-left: @size-small;
        color: @color-text-lighter;
      }
    }

    @about-decorate-top: 40px;
    @about-decorate-height: 64px;

    &-about {
      position: relative;
    }

    @group-buy-padding: 26px;

    &-group-buy {
      margin-top: -1px;
      padding: @group-buy-padding @group-buy-padding @size-extra-medium;
      background: @vip-detail-content-background;

      &-block {
        border-radius: 5px;
        overflow: hidden;
      }

      &-header {
        border-radius: 5px 5px 0 0;
        overflow: hidden;
      }
    }

    &-content {
      margin-top: -1px;
    }
  }

  .in-app {
    .vip-detail-content {
      &-price {
        font-size: 5.6vw;
        &-container {
          width: 62.4vw;
          height: 30.4vw;
          bottom: 10.6vw;
          padding: 8vw 2.6vw 8vw 4vw;
          &.gift {
            bottom: 380px;
          }
        }
        &-name {
          font-size: 5.3vw;
        }
        &-current {
          &-unit {
            margin-right: 1.3vw;
          }
          &-value {
            font-size: 9vw;
          }
        }
        &-delete {
          margin-left: 2.6vw;
        }
      }
    }
  }

  .new {
    .vip-detail-content {
      &-price {
        display: flex;
        align-items: flex-end;
        font-size: @vip-detail-price-container-font-size;

        &-container {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: absolute;
          top: 568px;
          height: 180px;
          left: 0;
          padding: 20px 40px;
          color: @color-text-base;
          background: none;
        }

        &-name {
          font-size: @vip-detail-price-container-font-size;
          font-weight: @font-weight-bold;
        }

        &-current {
          white-space: nowrap;
          line-height: 1;
          color: #ff0033;
          &-unit {
            margin-right: 0;
          }

          &-value {
            font-size: @vip-detail-price-font-size;
            font-weight: @font-weight-bold;
          }
        }

        &-delete {
          margin-left: 36px;
          color: #333;
          font-size: @vip-detail-price-container-font-size;
          font-weight: 400;
        }
      }
    }
  }
</style>
